export const ROUTE_PATHS = {
  AUTH: {
    LOGIN: "/login",
  },
  DASHBOARD: "/dashboard",
  SCHEDULE: {
    LIST: "/schedules",
    DETAIL: "/schedule/:scheduleId/details",
  },
  CLASS: {
    LIST: "/classes",
    DETAILS: "/class/:classId/details",
    SCHEDULES: "/class/:classId/class-schedules",
  },
  BOOKING: {
    TRAINER: {
      LIST: "/trainers/pt",
      DETAIL: "/trainer/details/:id",
      SCHEDULES: "/trainer-schedules/:id/service/:serviceId",
      PROGRAMS: "/trainer/programs/:id",
    },
    SWIMMING: "/swimming-booking",
  },
  FACILITIES: {
    LIST: "/facilities",
    DETAIL: "/facility/:facilityId",
    BOOKING: "/facility/:facilityId/booking",
  },
  // Walk-in guest flow (QTY-1991) — public, no member login. Namespaced under
  // /facilities so future walk-in flows (trainer, swimming, …) get their own space.
  WALK_IN: {
    LIST: "/facilities/walk-in",
    DETAIL: "/facilities/walk-in/:facilityId/details",
    BOOKING: "/facilities/walk-in/:facilityId",
    PAYMENT: "/facilities/walk-in/booking/:bookingId",
  },
  MYBOOKING: {
    LIST: "/my-bookings",
  },
  MEMBER: {
    INFORMATION: "/member",
    CREDIT: "/member-credit",
    LOYALTY: "/member-loyalty",
    LOYALTY_REDEEM: "/member-loyalty/redeem",
    LOYALTY_BENEFITS: "/member-loyalty/benefits",
    PAY_WITH_QR: "/member-pay-with-qr",
    CHECK_IN: "/member/check-in",
    GOALS: "/member/goals",
    DOCUMENTS: "/member/documents",
    FEEDBACK: "/member/feedback",
    PACKAGES: "/member/packages",
    GOAL_SETTING_DETAIL: "/goal-setting/:id/details",
    GOAL_SETTING_MORE_DETAIL: "/goal-setting/:id/more-details",
    GOAL_SETTING_TRAINNING_INFO: "/goal-setting/:id/training-info",
  },
};
